import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'container', 'group', 'content', 'chevron', 'row']

  connect() {
    this.allCollapsed = false
  }

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.groupTargets.forEach(group => {
      const rows = group.querySelectorAll('[data-user-name]')
      let visibleCount = 0

      rows.forEach(row => {
        const name = row.dataset.userName || ''
        const match = !query || name.includes(query)
        row.classList.toggle('hidden', !match)
        if (match) visibleCount++
      })

      group.classList.toggle('hidden', visibleCount === 0)
    })
  }

  toggleGroup(event) {
    const group = event.currentTarget.closest('[data-user-monitoring-search-target="group"]')
    const content = group.querySelector('[data-user-monitoring-search-target="content"]')
    const chevron = event.currentTarget.querySelector('[data-user-monitoring-search-target="chevron"]')

    content.classList.toggle('hidden')
    if (chevron) {
      chevron.classList.toggle('rotate-180')
    }
  }

  toggleAll(event) {
    this.allCollapsed = !this.allCollapsed
    event.currentTarget.textContent = this.allCollapsed ? 'Expandir todos' : 'Recolher todos'

    this.contentTargets.forEach(content => {
      content.classList.toggle('hidden', this.allCollapsed)
    })
    this.chevronTargets.forEach(chevron => {
      chevron.classList.toggle('rotate-180', this.allCollapsed)
    })
  }
}
